export function extractBaggageInfo(fareFamily?: App.FareFamily): {
  carryOnBaggage: App.FareFamilyFeature | undefined
  checkedBaggage: App.FareFamilyFeature | undefined
} {
  const carryOnBaggage = fareFamily?.fareFeatures.find(feature => (
    (
      // The `type` values coming from the API don't match what's defined in `App.FareFamilyFeatureType` :(
      feature.type === 'BAGGAGE_CARRY_ON' as App.FareFamilyFeatureType ||
      feature.type === 'carry_on_baggage'
    ) && feature.status === 'INCLUDED'
  ))

  const checkedBaggage = fareFamily?.fareFeatures.find(feature => (
    (
      feature.type === 'BAGGAGE_CHECKED' as App.FareFamilyFeatureType ||
      feature.type === 'checked_baggage'
    ) && feature.status === 'INCLUDED'
  ))

  return {
    carryOnBaggage,
    checkedBaggage,
  }
}
